import { basicAxios } from "./basicAxios";

export const makeGetZipList = () =>
  basicAxios.get("/api/zip-list");
